import { useEffect, useRef, useState } from 'react';
import { LANDING_LANGS, useLanding } from './i18n';
import { Icon } from './parts';

/** Globe + current language; opens a menu of the 12 languages the app supports. */
export default function LanguageSwitcher() {
  const { lang, setLang, t } = useLanding();
  const [open, setOpen] = useState(false);
  const root = useRef<HTMLDivElement>(null);
  const current = LANDING_LANGS.find((l) => l.code === lang) ?? LANDING_LANGS[0];

  useEffect(() => {
    if (!open) return;
    const onDown = (e: MouseEvent) => { if (!root.current?.contains(e.target as Node)) setOpen(false); };
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('mousedown', onDown);
    document.addEventListener('keydown', onKey);
    return () => { document.removeEventListener('mousedown', onDown); document.removeEventListener('keydown', onKey); };
  }, [open]);

  return (
    <div ref={root} className={`lsw${open ? ' open' : ''}`}>
      <button
        type="button"
        className="lsw-btn"
        aria-haspopup="listbox"
        aria-expanded={open}
        aria-label={t.nav.language}
        onClick={() => setOpen((v) => !v)}
      >
        <Icon name="globe" width={2} />
        <span className="nm">{current.label}</span>
        <svg className="c" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden><path d="M6 9l6 6 6-6" /></svg>
      </button>
      {open && (
        <div className="lsw-menu" role="listbox" aria-label={t.nav.language}>
          <div className="hd">{t.nav.language}</div>
          {LANDING_LANGS.map((l) => (
            <button
              key={l.code}
              type="button"
              role="option"
              aria-selected={l.code === lang}
              lang={l.code}
              className={l.code === lang ? 'on' : ''}
              onClick={() => { setLang(l.code); setOpen(false); }}
            >
              <span>{l.label}</span>
              {l.code === lang
                ? <svg className="ck" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden><path d="M5 12.5l4.5 4.5L19 7.5" /></svg>
                : <small>{l.short}</small>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
